import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {TradeEntity} from '../Entities/TradeEntity.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'

/**
 * @implements UseCase
 */
class RejectTradeBuyerTransactionsUseCase extends UseCase {
  #repository

  static create({config}) {
    return new RejectTradeBuyerTransactionsUseCase({repository: HTTPTransactionRepository.create({config})})
  }

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  @inlineError
  async execute({tradeId, reason}) {
    const tradeEntity = TradeEntity.create({id: tradeId})

    const [error] = await this.#repository.rejectTradeBuyer({tradeEntity, reason})

    if (error) throw error
  }
}

export default RejectTradeBuyerTransactionsUseCase.create
